import { render, staticRenderFns } from "./nu_pjud.vue?vue&type=template&id=24f4d41a&"
import script from "./nu_pjud.vue?vue&type=script&lang=js&"
export * from "./nu_pjud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports